<template>
    <footer>Puoi sostenere questo progetto con una <a href="https://paypal.me/pools/c/8bFReaiLUk">donazione</a>.<br>
      Se vuoi inviarmi un feedback fallo via <a href="mailto:castenetto.andrea@gmail.com">email</a>. <br> <a
        href="#">Torna su ⬆</a> &bull; <a href="https://castenettoa.com"
        title="creato da Andrea Castenetto">castenettoa.com</a> <br>
        <a href="blog/changelog">ChangeLog</a> </footer>
</template>